import React from 'react'
import Sidebar from './sidebar'
import Main from './main'

const Layout = () => {
  return (
    <>
        <Sidebar />
        <Main />
    </>
  )
}

export default Layout